<template>
  <div>
    <vs-popup v-if="boardUserData && boardUserData.userData" class="profile-card"
      :title="boardUserData.userData.firstName + `'s Profile Card`" :active.sync="profileCardPopupActive"
      :button-close-hidden="true">
      <profile-card-popup :boardUserData="boardUserData" />
    </vs-popup>
    <vs-popup v-if="coachData && getBoardUserDataById(coachData.coachUserId)" class="profile-card" :title="getBoardUserDataById(coachData.coachUserId).userData.firstName +
      `'s Profile Card`
      " :active.sync="coachProfileCardPopupActive" :button-close-hidden="true">
      <profile-card-popup :boardUserData="getBoardUserDataById(coachData.coachUserId)" />
    </vs-popup>


    <div v-if="currentBoard" class="user-card---kanban">
      <div v-if="userCardView === 'minimized' || !userCardView">
        <div v-if="boardUserData && boardUserData.userData" class="relative items-center">
          <div class="absolute z-1 top-0 right-0 mt-3 mr-3">
            <vx-tooltip class="cursor-pointer" text="Add a Note" @click.stop="showNotes = true">
              <feather-icon icon="MessageCircleIcon" svgClasses="w-5 h-5" style="color: #798ba0"
                @click.stop="showUserNotes()" />
            </vx-tooltip>
          </div>
          <vx-tooltip text="Click to view user progress">
            <div class="flex items-center" @click.stop="profileCardPopupActive = true">
              <div class="flex" style="position: relative">
                <vs-avatar v-if="
                  boardUserData &&
                  boardUserData.userData &&
                  boardUserData.userData.profilePictureUrl
                " size="32px" :src="constants.s3Bucket +
                  '/editor/profile-pictures/' +
                  boardUserData.userData.profilePictureUrl
                  " />
                <vs-avatar v-else size="32px" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                  boardUserData.userData.firstName,
                  boardUserData.userData.lastName
                )}`" />
                <img v-if="
                  ((boardUserData &&
                    boardUserData.boardUserConfigData &&
                    boardUserData.boardUserConfigData.userType === 'coach') ||
                    (boardUserData &&
                      boardUserData.boardUserConfig &&
                      boardUserData.boardUserConfig.userType === 'coach')) &&
                  currentBoard.installedApps &&
                  currentBoard.installedApps.includes('coach')
                " width="24px" :src="require(`@/assets/images/boards/${orgData.slug === 'gala' ? 'mentor' : 'coach'
                  }-badge.svg`)
                  " style="position: absolute; right: -1px; bottom: -5px" alt="" />
              </div>
              <div class="relative m-3">
                <h5 class="items-left">
                  {{ boardUserData.userData.firstName | title }}
                  {{ boardUserData.userData.lastName | title }}
                </h5>
                <p v-if="boardUserData.userData.profession" class="items-left mt-1">
                  {{ boardUserData.userData.profession }}
                </p>
              </div>
              <div v-if="
                ((boardUserData &&
                  boardUserData.boardUserConfigData &&
                  boardUserData.boardUserConfigData.userType === 'trainee') ||
                  (boardUserData &&
                    boardUserData.boardUserConfig &&
                    boardUserData.boardUserConfig.userType === 'trainee')) &&
                currentBoard.installedApps &&
                currentBoard.installedApps.includes('coach')
              " style="position: absolute; right: calc(0.5rem + 5px)">
                <vx-tooltip v-if="coachData && getBoardUserDataById(coachData.coachUserId)" class="cursor-pointer"
                  :text="orgData.slug === 'gala' ? 'Mentor' : 'Coach'">
                  <div>
                    <vs-avatar v-if="
                      getBoardUserDataById(coachData.coachUserId) &&
                      getBoardUserDataById(coachData.coachUserId).userData
                        .profilePictureUrl
                    " size="32px" :src="constants.s3Bucket +
                      '/editor/profile-pictures/' +
                      getBoardUserDataById(coachData.coachUserId).userData
                        .profilePictureUrl
                      " @click.stop="coachProfileCardPopupActive = true" />
                    <vs-avatar v-else-if="
                      boardUserData && getBoardUserDataById(boardUserData.userId)
                    " size="32px" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                      boardUserData.userData.firstName,
                      boardUserData.userData.lastName
                    )}`" @click.stop="coachProfileCardPopupActive = true" />
                    <img width="24px" :src="require(`@/assets/images/boards/${orgData && orgData.slug === 'gala' ? 'mentor' : 'coach'
                      }-badge.svg`)
                      " style="position: absolute; right: 0px; bottom: 0px" alt="" />
                  </div>
                </vx-tooltip>

                <vx-tooltip v-else class="cursor-pointer" :text="orgData && orgData.slug === 'gala'
                  ? 'Assign Mentor'
                  : 'Assign Coach'
                  ">
                  <img v-if="boardUserData && boardUserData.userData" width="32px"
                    :src="require('@/assets/images/boards/add-coach.svg')"
                    @click.stop="assignCoach(boardUserData.userData._id)" alt="" />
                </vx-tooltip>
              </div>
            </div>
          </vx-tooltip>
        </div>

        <div class="flex justify-between mx-2 mt-2 mb-0">

          <!-- <vx-tooltip class="cursor-pointer" text="Copy Profile Link">
            <feather-icon
              v-if="!showCopyIcon"
              icon="LinkIcon"
              svgClasses="w-5 h-5"
              style="color: #798ba0"
              @mousedown="
                copyUserProfileLink();
                showCopyIcon = true;
              "
            />
            <feather-icon
              v-else
              icon="CopyIcon"
              svgClasses="w-5 h-5"
              style="color: #798ba0"
              @mouseout="showCopyIcon = false"
            />
          </vx-tooltip> -->
        </div>
        <hr v-if="showNotes" class="mt-1 mb-3" style="border-top: #efefef" />
        <div v-show="fetchingNotes" id="div-notes-with-loading" class="vs-con-loading__container"
          style="min-height: 50px"></div>
        <div v-if="showNotes && !fetchingNotes">
          <div class="m-2 mb-5">
            <vs-input class="w-full" placeholder="Add a Note" v-model="note" @keyup.enter="saveNote" @blur="saveNote" />
          </div>
          <vx-timeline :data="notesData" @deleteKanbanNote="deleteKanbanNote" />
        </div>
      </div>
      <div v-else>
        <div v-if="boardUserData && boardUserData.userData">
          <div class="flex items-center">
            <div class="flex" style="position: relative">
              <vs-avatar v-if="boardUserData.userData.profilePictureUrl" size="60px" :src="constants.s3Bucket +
                '/editor/profile-pictures/' +
                boardUserData.userData.profilePictureUrl
                " @click.stop="profileCardPopupActive = true" />
              <vs-avatar v-else size="60px" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                boardUserData.userData.firstName,
                boardUserData.userData.lastName
              )}`" @click.stop="profileCardPopupActive = true" />
              <img v-if="
                ((boardUserData &&
                  boardUserData.boardUserConfigData &&
                  boardUserData.boardUserConfigData.userType === 'coach') ||
                  (boardUserData &&
                    boardUserData.boardUserConfig &&
                    boardUserData.boardUserConfig.userType === 'coach')) &&
                currentBoard.installedApps &&
                currentBoard.installedApps.includes('coach')
              " width="32px" :src="require('@/assets/images/boards/mentor-badge.svg')"
                style="position: absolute; right: 0px; bottom: -9px" alt="" />
            </div>
            <div class="relative m-3">
              <h4 class="mb-1 items-left">
                {{ boardUserData.userData.firstName | title }}
                {{ boardUserData.userData.lastName | title }}
              </h4>
              <p v-if="boardUserData.userData.profession" class="items-left">
                {{ boardUserData.userData.profession }}
              </p>
            </div>
            <div v-if="
              ((boardUserData &&
                boardUserData.boardUserConfigData &&
                boardUserData.boardUserConfigData.userType === 'trainee') ||
                (boardUserData &&
                  boardUserData.boardUserConfig &&
                  boardUserData.boardUserConfig.userType === 'trainee')) &&
              currentBoard.installedApps &&
              currentBoard.installedApps.includes('coach')
            " style="position: absolute; right: calc(0.5rem + 5px)">
              <vx-tooltip v-if="coachData" class="cursor-pointer">
                <div>
                  <vs-avatar v-if="
                    getBoardUserDataById(coachData.coachUserId) &&
                    getBoardUserDataById(coachData.coachUserId).userData
                      .profilePictureUrl
                  " size="32px" :src="constants.s3Bucket +
                    '/editor/profile-pictures/' +
                    getBoardUserDataById(coachData.coachUserId).userData
                      .profilePictureUrl
                    " @click.stop="coachProfileCardPopupActive = true" />
                  <vs-avatar v-else size="32px" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                    boardUserData.userData.firstName,
                    boardUserData.userData.lastName
                  )}`" @click.stop="coachProfileCardPopupActive = true" />
                  <img width="24px" :src="require(`@/assets/images/boards/${orgData.slug === 'gala' ? 'mentor' : 'coach'
                    }-badge.svg`)
                    " style="position: absolute; right: 0px; bottom: 0px" alt="" />
                </div>
              </vx-tooltip>
              <vx-tooltip v-else-if="boardUserData && boardUserData.userData" class="cursor-pointer"
                text="Assign Coach">
                <img width="32px" :src="require('@/assets/images/boards/add-coach.svg')"
                  @click.stop="assignCoach(boardUserData.userData._id)" alt="" />
              </vx-tooltip>
            </div>
          </div>
          <p v-if="boardUserData.userData.careerObjective" class="my-3 p-1">
            {{ boardUserData.userData.careerObjective }}
          </p>
          <div class="mb-3 p-1 kanban-skill-main" v-if="
            boardUserData.userData.extraCurricular[0] &&
            boardUserData.userData.extraCurricular[0].skills &&
            boardUserData.userData.extraCurricular[0].skills.length
          ">
            <span v-for="(skill, index) in boardUserData.userData.extraCurricular[0]
              .skills" :key="index" class="kanban-skill mr-3 mb-1">{{ skill.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VxTimeline from "./components/VxTimeline";
import constants from "@/constants.js";
// import UserDetailViewPpopup from "../../components/UserDetailViewPpopup.vue";
import ProfileCardPopup from "../../components/ProfileCardPopup.vue";

export default {
  props: {
    boardUserData: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    userCardView: {
      type: String,
      required: true,
      default: "minimized",
    },
    kanbanId: {
      type: String,
      required: true,
    },
    kanbanColId: {
      type: String,
      required: true,
    },
  },
  components: {
    VxTimeline,
    ProfileCardPopup
    // UserDetailViewPpopup,
  },
  data() {
    return {
      constants,
      profileCardPopupActive: false,
      notesData: [],
      note: "",
      showNotes: false,
      skillRating: 0,
      fetchingNotes: false,
      showCopyIcon: false,
      profilePercent: 0,
      localCoachData: {},
      coachProfileCardPopupActive: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    currentBoard() {
      return this.$store.state.boards.currentBoard;
    },
    boardUserName() {
      return this.boardUserData &&
        this.boardUserData.userData &&
        this.boardUserData.userData.firstName
        ? `${this.boardUserData.userData.firstName} ${this.boardUserData.userData.lastName}`
        : "";
    },
    coachData() {
      return this.boardUserData && this.boardUserData.userData
        ? this.$store.state.boards.coach[this.boardUserData.userData._id]
        : {};
    },
    currentBoardUsers() {
      return this.$store.state.boards.currentBoardUsers;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
  },
  methods: {
    saveNote() {
      if (
        !this.note ||
        !this.kanbanId ||
        !this.kanbanColId ||
        !this.boardUserData
      )
        return;

      const kanbanObj = {
        kanbanId: this.kanbanId,
        boardUserId: this.boardUserData._id,
        userId: this.userData._id,
        boardId: this.currentBoard._id,
        note: this.note,
      };

      const boardTitle = this.currentBoard.title;
      const organizationId = this.orgData._id;

      this.$store
        .dispatch("kanban/saveUserNote", {
          kanbanObj,
          boardTitle,
          boardUserName: this.boardUserName,
          organizationId,
        })
        .then((res) => {
          this.notesData.unshift(res);
          this.note = "";
        });
    },
    showUserNotes() {
      if (this.showNotes) {
        this.showNotes = false;
      } else {
        this.fetchNotes();
        this.showNotes = true;
      }
    },
    fetchNotes() {
      if (!this.kanbanId || !this.boardUserData) return;
      this.fetchingNotes = true;
      this.$vs.loading({
        container: "#div-notes-with-loading",
        scale: 0.5,
      });

      this.$store
        .dispatch("kanban/fetchAllUserNotes", {
          boardUserId: this.boardUserData._id,
          kanbanId: this.kanbanId,
        })
        .then((res) => {
          this.notesData = res.data;
          this.fetchingNotes = false;

          this.$vs.loading.close("#div-notes-with-loading > .con-vs-loading");
        });
    },
    deleteKanbanNote(kanbanNoteId) {
      if (!kanbanNoteId) return;

      const boardTitle = this.currentBoard.title;
      const organizationId = this.orgData._id;

      this.$store
        .dispatch("kanban/deleteUserNote", {
          kanbanNoteId,
          boardTitle,
          boardUserName: this.boardUserName,
          organizationId,
        })
        .then((res) => {
          const i = this.notesData.findIndex((nd) => {
            return nd._id === kanbanNoteId;
          });
          this.notesData.splice(i, 1);
        });
    },
    copyUserProfileLink() {
      if (!this.boardUserData) return "#";

      const userProfileLink = `${constants.url}/${this.boardUserData.boardData.slug}/${this.boardUserData._id}/profile/${this.boardUserData.userData.slug}`;
      navigator.clipboard.writeText(userProfileLink);

      this.$store.dispatch("organization/logOrganizationActivity", {
        organizationId: this.currentBoard.organizationId,
        logObj: {
          logText: `Copied ${this.currentBoard.title} board user (${this.boardUserName})'s profile link`,
          status: "active",
          boardId: this.currentBoard._id,
          userId: this.userData._id,
        },
      });
    },
    assignCoach(traineeId) {
      try {
        this.$emit("assignCoach", traineeId);
      } catch (error) {
        console.error(error);
      }
    },
    getBoardUserDataById(userId) {
      return this.currentBoardUsers.find((boardUser) => {
        return userId == boardUser.userId;
      });
    },
  },
  created() { },
};
</script>

<style scoped>
.user-name--item h4 {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  /* identical to box height */

  letter-spacing: -0.02em;
  text-transform: capitalize;

  color: #192a46;
}

.user-name--item span {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #636175;
}

.level--item {
  background: rgba(36, 98, 238, 0.1);
  border-radius: 4px;
}

.level--item h4 {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  /* identical to box height */
  display: flex;
  align-items: center;
  color: #2462ee;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 10px;
}

.user-details--item .location {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */
  display: flex;
  align-items: center;
  color: #a3a3a3;
}

.message-btn {
  background: #f4f6f8;
  border-radius: 6px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: -0.02em;

  color: #081343;
}

.profile-card .name {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 34px;
  line-height: 41px;
  letter-spacing: -0.02em;
  /* Licorice */
  color: #30384b;
}

.profile-card .role-title {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 29px;
  /* Light Slate Grey */
  color: #798ba0;
}

.profile-card .current-location,
.profile-card .email {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  /* Echo Blue */
  color: #b2bac8;
}

.profile-card .heading {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 13px;
  /* identical to box height, or 93% */
  letter-spacing: 0.03em;
  text-transform: uppercase;
  /* Echo Blue */
  color: #b2bac8;
}

.profile-card .content {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  /* or 144% */
  /* Light Slate Grey */
  color: #798ba0;
}

.kanban-skill {
  background: rgba(var(--vs-primary), 0.2) !important;
  border-radius: 4px;
  color: rgba(var(--vs-primary), 1) !important;
  padding: 1px 12px;
  line-height: 2;
  float: left;
  font-size: 10px;
}

.kanban-skill-main:after {
  clear: both;
  height: 0;
  width: 100%;
  content: "";
  display: block;
}

.profile-card>>>.vs-popup--header {
  display: none !important;
}

.profile-card>>>.vs-popup {
  width: 950px;
}

.con-vs-popup>>>.vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
  overflow-x: hidden !important;
  width: auto !important;
  border-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
</style>
